import { getConfiguration, verifyExtend, ExtendError } from "./extend-utils.js";

const offerTagName = 'extend-cart-offer';

const {
    cartOfferEnabled,
    cartSPEnabled,
    sideCartOfferEnabled,
    cartBalancingEnabled,
    analyticsEnabled
} = getConfiguration();

let selectors;
let type;
if (window.location.pathname.includes('cart')) {
    selectors = {
        cartContainerSelector: 'cart-form', // Cart container
        cartRowItem: '[data-merge-list="cart-items"] [data-merge-list-item] .cart-item', // Container element for each item in the cart
        cartRowItemImage: '.cart-item__image a', // Product image or image anchor element
        cartRowItemTitle: '.cart-item__title a', // Title anchor element for the product
        cartRowItemQuantity: '.cart-item__quantity-input', // Input element containing the product quantity
        warrantyOriginalMeta: '.line-item-property,.cart-item__variant', // Each warranty metadata item we want to remove.
        offerContainer: '.cart-item__description', // Container where the offer will be appended
        metadataContainer: '.cart-item__description .small-text', // Where warranty metadata will be appended (Product and Term)
        quantityWrapper: '.quantity' // Wrapper for quantity input and buttons
    };
    type = 'main';
    
} else {
    selectors = {
        cartContainerSelector: 'cart-form.cart-drawer', // Cart container
        cartRowItem: '[data-merge-list="cart-items"] [data-merge-list-item]', // Container element for each item in the cart
        cartRowItemImage: '.cart-item__image', // Product image or image anchor element
        cartRowItemTitle: '.cart-item__title a', // Title anchor element for the product
        cartRowItemQuantity: '.cart-item__quantity-input', // Input element containing the product quantity
        warrantyOriginalMeta: '.line-item-property,.cart-item__variant', // Each warranty metadata item we want to remove.
        offerContainer: '.cart-item__description', // Container where the offer will be appended
        metadataContainer: '.cart-item__description .small-text', // Where warranty metadata will be appended (Product and Term)
        quantityWrapper: '.quantity' // Wrapper for quantity input and buttons
    }
    type = 'side';
}

let cart;

class ExtendCartOffer extends HTMLElement {
    constructor(referenceId, quantity, price, category) {
        super();

        this.params = {
            referenceId,
            quantity,
            price,
            category
        }
    }

    connectedCallback() {
        Extend.buttons.renderSimpleOffer(this, {
            referenceId: this.params.referenceId,
            price: this.params.price,
            category: this.params.category,
            onAddToCart: ({ plan, product }) => {
                ExtendShopify.addPlanToCart({
                    plan,
                    product,
                    quantity: this.params.quantity
                }, (err) => {
                    if (err) {
                        throw new ExtendError(err.message);
                    }
                    refreshCartMarkup();
                })
            }
        })
    }
}
customElements.define(offerTagName, ExtendCartOffer);

function createElement(lineItemElement, index) {
    const cartItem = cart.items[index];

    const referenceId = cartItem.id;
    const quantity = cartItem.quantity;
    const price = cartItem.price;
    const category = cartItem.product_type;
    const warrantyAlreadyInCart = ExtendShopify.warrantyAlreadyInCart(referenceId, cart.items);

    if (type == 'side' && !sideCartOfferEnabled) return;
    if (type == 'main' && !cartOfferEnabled) return;
    
    // Parent container to append cart offer
    let container = lineItemElement.querySelector(selectors.offerContainer);
            
    if (!container) {
        throw new ExtendError(`Offer container unavailable on line item ${index + 1}`);
    }
    
    // If an offer exists, remove it if the quantity or reference ID do not match
    let extendOffer = lineItemElement.querySelector(offerTagName);
    if (extendOffer) {
        if (extendOffer.dataset.extendReferenceId !== referenceId ||
            extendOffer.dataset.extendQuantity !== quantity ||
            extendOffer.dataset.extendPrice !== price ||
            extendOffer.dataset.extendCategory !== category ||
            warrantyAlreadyInCart) {

            extendOffer.remove();
        } else {
            return;
        }
    }

    if (warrantyAlreadyInCart) return;

    extendOffer = new ExtendCartOffer(referenceId, quantity, price, category);
    container.append(extendOffer);
}

function styleCart() {
    let container = document.querySelector(selectors.cartContainerSelector);
        
    if (!container) {
        throw new ExtendError(`Invalid cart container selector ${cartContainerSelector}`);
    }
    
    container.querySelectorAll(selectors.cartRowItem).forEach((lineItemElement, index) => {
        let title = lineItemElement.querySelector(selectors.cartRowItemTitle);
        
        if (!title) {
            throw new ExtendError('Line item title not found');
        }

        let lowerCaseTitle = title.textContent.toLowerCase();
        
        if (lowerCaseTitle.indexOf('extend protection') > -1) {
            // Select and remove pointerEvents from warranty title
            title.style.pointerEvents = 'none';
            
            let image = lineItemElement.querySelector(selectors.cartRowItemImage);
            
            if (!image) {
                throw new ExtendError(`Image unavailable for line item ${title.innerText}`);
            }
            
            // Select and remove pointerEvents from warranty image
            image.style.pointerEvents = 'none';
            
            
            /**************************************/
            /* THEME SPECIFIC STYLING START       */
            /**************************************/
            // Removes old metadata

            if (lineItemElement.querySelector(selectors.warrantyOriginalMeta)) {
                lineItemElement.querySelectorAll(selectors.warrantyOriginalMeta).forEach((each) => {
                    each.remove();
                })
            }
            
            if (selectors.quantityWrapper?.length && lineItemElement.querySelector(selectors.quantityWrapper) && type == 'main') {
                lineItemElement.querySelectorAll(selectors.quantityWrapper).forEach((each) => {
                    each.style.opacity = '75%';
                    each.style.pointerEvents = 'none';
                })
            }
            
            // Selects where to append warranty metadata
            let contentContainer = lineItemElement.querySelector(selectors.metadataContainer)
            let warrantyProductData;
            let warrantyTermData;
            let cartItem = cart.items[index];
            
            if (cartItem.options_with_values && cartItem.options_with_values[1]) { // Finds the ref id string in the product info string and replaces with an empty string
                let regexReplace = cartItem.options_with_values[0].value.match(/\-\d{5,}/g);
                warrantyProductData = cartItem.options_with_values[0].value.replace(regexReplace, '');
                warrantyTermData = cartItem.options_with_values[1].value;
            } else {
                warrantyProductData = cartItem.properties.Product;
                warrantyTermData = cartItem.properties.Term;
            }
            
            // For category offers, fetch title by filtering through cart for warranted product refId
            if (warrantyProductData === "Covered Product") {
                const coveredProductId = cartItem.properties['_Extend.ProductId'];
                warrantyProductData = cart.items.find((item) => item.id.toString() == coveredProductId).title;
            }
            
            // Appends Product and Term metadata
            if (lineItemElement.querySelector(selectors.metadataContainer)) {
                let warrantyProductName = document.createElement('p');
                warrantyProductName.className = 'extend-warranty-info extend-warranty-info-product';
                warrantyProductName.innerHTML = '<b>Product: </b>' + warrantyProductData;
                
                let warrantyProductTerm = document.createElement('p')
                warrantyProductTerm.className = 'extend-warranty-info extend-warranty-info-term';
                warrantyProductTerm.innerHTML = '<b>Term: </b>' + warrantyTermData;
                
                // Only append the metadata if it's not already there
                if (!lineItemElement.querySelector('.extend-warranty-info')) {
                    contentContainer.append(warrantyProductName, warrantyProductTerm)
                }
            }
            
            /**************************************/
            /* THEME SPECIFIC STYLING END         */
            /**************************************/
        } else if (lowerCaseTitle.indexOf('extend shipping') > -1) {
            lineItemElement.style.display = 'none';
        } else {
            createElement(lineItemElement, index);
        }
    });
}

async function getCart() {
    let cartResponse = await fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    });
    return await cartResponse.json();
}

function refreshCartMarkup() {
    document.dispatchEvent(new Event('theme:cartchanged'), { bubbles: true, cancelable: false });
}

export function initCartOffer() {
    verifyExtend();

    ExtendShopify.updateExtendLineItems({
        balanceCart: cartBalancingEnabled,
        isSPSupported: cartSPEnabled,
        callback: (err, data) => {
            if (err) {
                throw new ExtendError(err);
            } else if (data?.updates) {
                refreshCartMarkup();
            }
            cart = data.cart;
            styleCart();

        }
    });
}

document.addEventListener('extend.refreshCartOffer', () => {
    setTimeout(initCartOffer, 500);
});
